import React, { useState, useEffect } from "react";
import { CalculatorState } from "../calculator.utility";
import styled from "styled-components";
import { formatTime, formatDistance, formatPace } from "../pace-fns/pace-fns";

const HeaderTitle = "Metrics";
const TimeHeader = "Time";
const PaceHeader = "Pace";
const DistanceHeader = "Distance";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 125px;
  justify-content: center;
  align-items: center;
`;

const HorizontalLine = styled.div`
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1px 0;
    padding-bottom: 5px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 21px 56px 21px 56px;
  border-radius: 8px;
  border: 1px solid #ffffff;
  box-shadow: 15px 15px 10px #f3f4ee, -15px -15px 10px #f7f8f2;
  overflow: hidden;
  background-color: #fefffc;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
`;
const RowHeader = styled.span`
    padding-right: 10px;
`;
const RowData = styled.span``;

const HeaderInfo = styled(InfoItem)`
  font-weight: 500;
`;

type Props = { metrics: CalculatorState };

export const SummaryView = ({ metrics }: Props) => {
  const [formattedPace, setFormattedPace] = useState("");
  const [formattedDistance, setFormattedDistance] = useState("");
  const [formattedTime, setFormattedTime] = useState("");

  useEffect(() => {
    setFormattedTime(formatTime(metrics.time));
    setFormattedDistance(formatDistance(metrics.distance));
    setFormattedPace(formatPace(metrics.pace));
  }, [metrics]);

  return (
    <Container>
      <Content>
        <HeaderInfo>{HeaderTitle.toUpperCase()}</HeaderInfo>
        <HorizontalLine />
        <InfoItem>
          <RowHeader>{TimeHeader}</RowHeader>
          <RowData>{formattedTime}</RowData>
        </InfoItem>
        <InfoItem>
          <RowHeader>{DistanceHeader}</RowHeader>
          <RowData>{formattedDistance}</RowData>
        </InfoItem>
        <InfoItem>
          <RowHeader>{PaceHeader}</RowHeader>
          <RowData>{formattedPace}</RowData>
        </InfoItem>
      </Content>
    </Container>
  );
};
